export default (context, inject) => {
  const scrollToTop = () => {
    if (process.client) {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }
    return true
  }

  inject('scrollToTop', scrollToTop)
  context.$scrollToTop = scrollToTop
}
